export default "__VITE_ASSET__B8gnTBA1__"